import React from 'react';

const Footer: React.FC = ({ children }) => (
  <div className="change-email-modal--footer">{children}</div>
);

export default Footer;
